import { LoaderFunctionArgs } from 'react-router';
import { QueryParamNames } from './enums/QueryParamNames';
import { BooleanParam, NumberParam, StringParam, withDefault } from 'use-query-params';

export function searchLoader({ request }: LoaderFunctionArgs) {
    const params = new URL(request.url).searchParams;

    if (!sessionStorage.getItem('level-filters'))
        sessionStorage.setItem(
            'level-filters',
            JSON.stringify({
                [QueryParamNames.NAME]: StringParam.decode(params.get(QueryParamNames.NAME) ?? undefined),
                [QueryParamNames.CREATOR]: StringParam.decode(params.get(QueryParamNames.CREATOR) ?? undefined),
                [QueryParamNames.SONG]: StringParam.decode(params.get(QueryParamNames.SONG) ?? undefined),
                [QueryParamNames.SORT]: withDefault(StringParam, 'ID').decode(
                    params.get(QueryParamNames.SORT) ?? undefined,
                ),
                [QueryParamNames.SORT_DIRECTION]: withDefault(StringParam, 'asc').decode(
                    params.get(QueryParamNames.SORT_DIRECTION) ?? undefined,
                ),
                [QueryParamNames.MIN_RATING]: NumberParam.decode(params.get(QueryParamNames.MIN_RATING) ?? undefined),
                [QueryParamNames.MAX_RATING]: NumberParam.decode(params.get(QueryParamNames.MAX_RATING) ?? undefined),
                [QueryParamNames.MIN_ENJOYMENT]: NumberParam.decode(
                    params.get(QueryParamNames.MIN_ENJOYMENT) ?? undefined,
                ),
                [QueryParamNames.MAX_ENJOYMENT]: NumberParam.decode(
                    params.get(QueryParamNames.MAX_ENJOYMENT) ?? undefined,
                ),
                [QueryParamNames.DIFFICULTY]: StringParam.decode(params.get(QueryParamNames.DIFFICULTY) ?? undefined),
                [QueryParamNames.LENGTH]: NumberParam.decode(params.get(QueryParamNames.LENGTH) ?? undefined),
                [QueryParamNames.MIN_SUBMISSION_COUNT]: NumberParam.decode(
                    params.get(QueryParamNames.MIN_SUBMISSION_COUNT) ?? undefined,
                ),
                [QueryParamNames.MAX_SUBMISSION_COUNT]: NumberParam.decode(
                    params.get(QueryParamNames.MAX_SUBMISSION_COUNT) ?? undefined,
                ),
                [QueryParamNames.MIN_ENJOYMENT_COUNT]: NumberParam.decode(
                    params.get(QueryParamNames.MIN_ENJOYMENT_COUNT) ?? undefined,
                ),
                [QueryParamNames.MAX_ENJOYMENT_COUNT]: NumberParam.decode(
                    params.get(QueryParamNames.MAX_ENJOYMENT_COUNT) ?? undefined,
                ),
                [QueryParamNames.MIN_DEVIATION]: NumberParam.decode(
                    params.get(QueryParamNames.MIN_DEVIATION) ?? undefined,
                ),
                [QueryParamNames.MAX_DEVIATION]: NumberParam.decode(
                    params.get(QueryParamNames.MAX_DEVIATION) ?? undefined,
                ),
                [QueryParamNames.MIN_ID]: NumberParam.decode(params.get(QueryParamNames.MIN_ID) ?? undefined),
                [QueryParamNames.MAX_ID]: NumberParam.decode(params.get(QueryParamNames.MAX_ID) ?? undefined),
                [QueryParamNames.TWO_PLAYER]: StringParam.decode(params.get(QueryParamNames.TWO_PLAYER) ?? undefined),
                [QueryParamNames.UPDATE]: StringParam.decode(params.get(QueryParamNames.UPDATE) ?? undefined),
                [QueryParamNames.TOP_TAG_ID]: StringParam.decode(params.get(QueryParamNames.TOP_TAG_ID) ?? undefined),
                [QueryParamNames.EXCLUDE_COMPLETED]: BooleanParam.decode(
                    params.get(QueryParamNames.EXCLUDE_COMPLETED) ?? undefined,
                ),
                [QueryParamNames.EXCLUDE_UNRATED]: BooleanParam.decode(
                    params.get(QueryParamNames.EXCLUDE_UNRATED) ?? undefined,
                ),
                [QueryParamNames.EXCLUDE_UNRATED_ENJOYMENT]: BooleanParam.decode(
                    params.get(QueryParamNames.EXCLUDE_UNRATED_ENJOYMENT) ?? undefined,
                ),
                [QueryParamNames.EXCLUDE_RATED]: BooleanParam.decode(
                    params.get(QueryParamNames.EXCLUDE_RATED) ?? undefined,
                ),
                [QueryParamNames.EXCLUDE_RATED_ENJOYMENT]: BooleanParam.decode(
                    params.get(QueryParamNames.EXCLUDE_RATED_ENJOYMENT) ?? undefined,
                ),
                [QueryParamNames.IN_PACK]: BooleanParam.decode(params.get(QueryParamNames.IN_PACK) ?? undefined),
            }),
        );

    return null;
}
